module.exports = __webpack_public_path__ + "static/media/self-image.358c52da.jpg";